<template>
  <el-dialog
      :visible.sync="visible"
      title="箱单发货数量调整"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
      :append-to-body="true"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="120px"
        :rules="dataRule"
    >
      <el-row :gutter="16" style="padding-left: 10px;">
        <el-col :span="6">
          <el-form-item prop="code" label="进出口发票号：">
            {{dataForm.receiptCode}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="operateDate" label="装船日期：">
            {{dataForm.shipDate}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="sellerId" label="外销合同号：" >
            {{dataForm.agreementCode}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="remark" label="品番号：" >
            {{dataForm.code}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="skuCode" label="SKU：" >
            {{dataForm.skuCode}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="name" label="品名：" >
            {{dataForm.name}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="color" label="颜色：" >
            {{dataForm.color}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="size" label="规格：" >
            {{dataForm.size}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="totalCount" label="发货数量：" >
            {{dataForm.totalCount}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="newCount" label="调整数量：" >
            <el-input v-model="dataForm.newCount" size="mini"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import PayDetailSelDialog from '@/views/modules/erp/pay/PayDetailSelDialog.vue'
import BigNumber from 'bignumber.js'
import { isNumber, moneyValidator } from '@/utils/validate'
import debounce from 'lodash/debounce'

export default {
  name:'edit-count-dialog',
  components: {  },
  data () {
    return {
      dataForm: {},
      visible: false,
      dataRule: {
        newCount: [
          { required: true, message: '请填写要调整的数量', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback()
              }
              if (!isNumber(value)) {
                callback(new Error('请输入正确的数字'))
              }
              callback()
            }, trigger: 'change'
          },
        ],
      }
    }
  },
  computed: {

  },
  methods: {
    init (data) {
      this.$set(this,'dataForm',data)
      this.visible = true
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            let postForm = {
              boxDetailId:this.dataForm.id,
              totalCount:this.dataForm.newCount
            }
            if (this.saving) {
              return
            }
            this.saving = true
            this.$api2.post('/erp/box/detail/changeCount', postForm).then(res => {
              this.saving = false
              this.$emit('complete')
              this.$c.success(this.$t('prompt.success')).then(() => {
                this.visible=false
              })
            }).catch(() => {
              this.saving = false
            })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  }
}
</script>

<style scoped>

</style>
